import { useEffect, useState } from "react";
import API from "../services/api-request";
import { Row, Select, Spin } from "antd";
import { capitalizeLetter } from "../utils/capitalizeLetter";

const SelectMaterialHandling = ({ value, onChange, disabled }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getMaterialHandling = async () => {
    setLoading(true);
    API.Get(`material-handling`)
      .then((res) => {
        const newData = res?.data;
        const filteredData = newData.filter(
          (item) =>
            !listData.find((existingItem) => existingItem.id === item.id)
        );
        setData((prevData) => [...prevData, ...filteredData]);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getMaterialHandling();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear={false}
      disabled={disabled}
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Material Handling"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: capitalizeLetter(e.type),
        value: e.type,
        cost: e.cost,
      }))}
    />
  );
};

export default SelectMaterialHandling;
